module.exports = __webpack_public_path__ + "img/kmlookbook7web.260d135d.jpg";